module.exports = __webpack_public_path__ + "img/IND-B-2-V.86d95f98.png";